import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WebMcpConfirmDialogData {
  title: string;
  message: string;
  details: { label: string; value: string }[];
}

@Component({
  selector: 'app-webmcp-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="dialog-wrapper" data-testid="webmcp-confirm-dialog">
      <div class="dialog-title">{{ data.title }}</div>
      <div class="dialog-content">
        <p class="dialog-message">{{ data.message }}</p>
        <dl class="dialog-details">
          <ng-container *ngFor="let detail of data.details">
            <dt>{{ detail.label }}</dt>
            <dd>{{ detail.value || '--' }}</dd>
          </ng-container>
        </dl>
      </div>
      <div class="dialog-actions">
        <button type="button" class="cancel-btn" data-testid="webmcp-confirm-cancel" (click)="onCancel()">Cancel</button>
        <button type="button" class="confirm-btn" data-testid="webmcp-confirm-approve" (click)="onConfirm()">Approve</button>
      </div>
    </div>
  `,
  styleUrls: ['./webmcp-confirm-dialog.component.scss'],
})
export class WebMcpConfirmDialogComponent {
  dialogRef = inject(MatDialogRef<WebMcpConfirmDialogComponent>);
  data = inject(MAT_DIALOG_DATA) as WebMcpConfirmDialogData;

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
